import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AuthConstants } from '../AuthConstants';
import { User } from '../Model/user';
import { environment } from '../../environments/environment';
import {iClient} from '../Model/ClientModel';
import {AuthService} from '../auth/AuthService';

@Injectable({providedIn:'root'})
export class UserService{



    constructor(private httpClient: HttpClient,
                private authService: AuthService,){

    }
    postUser(user:User):Observable<any>{

        return this.httpClient.post(environment.apiRoot+environment.userService+'user/dental', user);

    }

    getAllUsers(params?:any): Observable<any> {
        return this.authService.getP(`${environment.userService}user`, params);
    }

    createUser(client): Observable<any> {
        return this.authService.post(`${environment.userService}user`, client);
    }

    getUserDetails(params?:any): Observable<any> {
        return this.authService.getP(`${environment.userService}user`, params);
    }

    updateUser(body: any, params?:any): Observable<any> {
        return this.authService.put(`${environment.userService}user`,body, params);
    }

    deleteUser(params?:any): Observable<any> {
        return this.authService.delete(`${environment.userService}user`, params);
    }

  deleteHmo(params?:any): Observable<any> {
    return this.authService.delete(`${environment.batchJob}hmo`, params);
  }

    resetPassword(body?:any): Observable<any> {
        return this.authService.post(`${environment.userService}user/update-password`, body);
    }

    // Timezone API
    updateTimezone(body?:any, params?: any): Observable<any> {
      return this.authService.patchP(`${environment.userService}userprofile`,body, params);
    }

}
